import { render, staticRenderFns } from "./pointPreview.vue?vue&type=template&id=6618f7c8&scoped=true"
import script from "./pointPreview.vue?vue&type=script&lang=js"
export * from "./pointPreview.vue?vue&type=script&lang=js"
import style0 from "./pointPreview.vue?vue&type=style&index=0&id=6618f7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618f7c8",
  null
  
)

export default component.exports